<div class="p-grid" style="margin-bottom: 10px;">
    <div class="p-col p-p-0">
        <ng-container *ngFor="let col of column1">
            <div *ngIf="col.enabled && data && col.columnName != 'address' && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)"
                class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
                <div style="width: 25%;word-break: break-word;" pTooltip="{{ col.name }}"><strong>{{col.name}}</strong>
                </div>
                <span style="width: 75%;" [class.popup-opener]="linkFields.includes(col.columnName)"
                    (click)="setDetailsPopupData(col.columnName,data)">
                    <ng-container *ngIf="(['twitter','website','other','facebook','linkedin','instagram', 'social', 'contactsocialtwitter',
                                    'contactsocialwebsite','contactsocialfacebook', 'contactsociallinkedin','contactsocialinstagram']
                                    .indexOf(col.columnName) >= 0|| ['URL'].includes(col?.formControlType)); else elseData">
                        <a href="{{data[col.columnName] | url}}" target="_blank">{{data[col.columnName] | shorten }}</a>
                    </ng-container>
                    <ng-template #elseData>
                        <div pTooltip="{{data[col.columnName]}}" style="white-space: pre-line;word-break: break-all;" tooltipPosition="top"
                            [hidden]="col.columnName == 'attachmentLinks' || col.columnName == 'tags' || phoneFields.includes(col.columnName)
                            || ['Percentage','Currency','RichText','Time'].includes(col?.formControlType) || activityDate.includes(col?.columnName)">

                            <ng-container *ngIf="col.columnName =='businessName' && data?.sequenceNumber && mergeAccountSequenceNumber">
                                {{ data?.sequenceNumber }} -
                            </ng-container>
                            <ng-container *ngIf="col.columnName =='mainCustomer' && data?.parentAccountSequenceNumber">
                                {{ data?.parentAccountSequenceNumber }} -
                            </ng-container>
                            {{data[col.columnName] | shorten: 100}}

                            <span *ngIf="col.columnName === 'currentStage' && data?.isConvertedToAccount && data?.leadStageId == qualifiedId">*</span>
                        </div>
                        <ng-container *ngIf="col?.columnName=='taskDueDate'">
                            <span tooltipPosition="top" [pTooltip]="getDateTooltip(getDateClass(data[col.columnName]))" class="date-background" [ngClass]="getDateClass(data[col.columnName])">
                                {{ data[col.columnName] | localDate:'dateTime'}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="col?.columnName=='latestEventDate'">
                            <span tooltipPosition="top" [pTooltip]="getEventTooltip(getDateClass(data[col.columnName]))" class="date-background" [ngClass]="getDateClass(data[col.columnName])">
                                {{ data[col.columnName] | localDate:'dateTime'}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="col?.columnName=='lastActivityDate'">
                            {{ data[col.columnName] | localDate:'dateTime'}}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='Percentage'">
                            {{ data[col.columnName] | percentageSymbol }}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='Currency' && data[col.columnName]">
                            {{ data[col.columnName] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol }}
                            
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='RichText'">
                            {{ data[col.columnName] | removeHtmlTags | shorten }}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='Time'">
                            {{ data[col.columnName] | onlyTime }}
                        </ng-container>
                        <div *ngIf="phoneFields.includes(col.columnName)" pTooltip="{{data[col.columnName]}}" style="white-space: pre-line;word-break: break-all;" tooltipPosition="top">
                            {{ data[col.columnName] | phoneNumber: data[col.columnName+'Code'] }}
                        </div>
                        <div *ngIf="col.columnName == 'attachmentLinks'">
                            <div *ngFor="let file of data[col.columnName]" style="cursor: pointer;">
                                <a (click)="openFilePreview(file)">
                                    {{ file.name | shorten: 30}}
                                </a>
                            </div>
                        </div>
                        <div *ngIf="col.columnName == 'tags'">
                            <span *ngFor="let tag of data[col.columnName]">
                                <p-tag [value]="tag?.name" styleClass="p-ml-2" [style]="{'background-color': tag?.color}"></p-tag>
                            </span>
                        </div>
                    </ng-template>
                </span>
            </div>
        </ng-container>
        <div *ngIf="column1Address" class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
            <div style="width: 25%;word-break: break-word;"><strong>{{column1Address.name}}</strong></div>
            <div style="width: 75%;">
                <p *ngIf="data && data['streetAddress1']" class="p-mb-0">{{data['streetAddress1']}},</p>
                <p *ngIf="data && data['streetAddress2']" class="p-mb-0">{{data['streetAddress2']}},</p>
                <p *ngIf="data && data['cityStateCountry']" class="p-mb-0">{{data['cityStateCountry']}}</p>
            </div>
        </div>
    </div>

    <p-divider *ngIf="column2.length" layout="vertical"></p-divider>

    <div *ngIf="column2.length" class="p-col p-p-0">
        <ng-container *ngFor="let col of column2">
            <div *ngIf="col.enabled && data && col.columnName != 'address' && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)"
                class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
                <div style="width: 25%;word-break: break-word;" pTooltip="{{ col.name }}"><strong>{{col.name}}</strong>
                </div>
                <span style="width: 75%;" [class.popup-opener]="linkFields.includes(col.columnName)"
                    (click)="setDetailsPopupData(col.columnName)">
                    <ng-container *ngIf="(['twitter','website','other','facebook','linkedin','instagram','social', 'contactsocialtwitter',
                        'contactsocialwebsite','contactsocialfacebook', 'contactsociallinkedin','contactsocialinstagram']
                        .indexOf(col.columnName) >= 0 || ['URL'].includes(col?.formControlType)); else elseData">
                        <a href="{{data[col.columnName] | url}}" target="_blank">{{data[col.columnName] | shorten }}</a>
                    </ng-container>
                    <ng-template #elseData>
                        <div pTooltip="{{data[col.columnName]}}" tooltipPosition="top" style="white-space: pre-line;"
                            [hidden]="col.columnName == 'attachmentLinks' || col.columnName == 'tags' || phoneFields.includes(col.columnName)
                            || ['Percentage','Currency','RichText','Time'].includes(col?.formControlType) || activityDate.includes(col?.columnName)">

                            <ng-container *ngIf="col.columnName =='businessName' && data?.sequenceNumber && mergeAccountSequenceNumber">
                                {{ data?.sequenceNumber }} -
                            </ng-container>
                            <ng-container *ngIf="col.columnName =='mainCustomer' && data?.parentAccountSequenceNumber">
                                {{ data?.parentAccountSequenceNumber }} -
                            </ng-container>
                                {{data[col.columnName] | shorten: 100}}
                            <span *ngIf="col.columnName === 'currentStage' && data?.isConvertedToAccount && data?.leadStageId == qualifiedId">*</span>
                        </div>
                        <ng-container *ngIf="col?.columnName=='taskDueDate'">
                            <span tooltipPosition="top" [pTooltip]="getDateTooltip(getDateClass(data[col.columnName]))" class="date-background" [ngClass]="getDateClass(data[col.columnName])">
                                {{ data[col.columnName] | localDate:'dateTime'}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="col?.columnName=='latestEventDate'">
                            <span tooltipPosition="top" [pTooltip]="getEventTooltip(getDateClass(data[col.columnName]))" class="date-background" [ngClass]="getDateClass(data[col.columnName])">
                                {{ data[col.columnName] | localDate:'dateTime'}}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="col?.columnName=='lastActivityDate'">
                            {{ data[col.columnName] | localDate:'dateTime'}}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='Percentage'">
                            {{ data[col.columnName] | percentageSymbol }}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='Currency'">
                            {{ data[col.columnName] | customNumberFormat:maximumFractionDigits | currencySymbol: null : col?.currencySymbol }}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='RichText'">
                            {{ data[col.columnName] | removeHtmlTags | shorten }}
                        </ng-container>
                        <ng-container *ngIf="col?.formControlType=='Time'">
                            {{ data[col.columnName] | onlyTime }}
                        </ng-container>
                        <div *ngIf="phoneFields.includes(col.columnName)" pTooltip="{{data[col.columnName]}}" style="white-space: pre-line;word-break: break-all;" tooltipPosition="top">
                            {{ data[col.columnName] | phoneNumber: data[col.columnName+'Code'] }}
                        </div>
                        <div *ngIf="col.columnName == 'attachmentLinks'" style="cursor: pointer;">
                            <div *ngFor="let file of data[col.columnName]">
                                <a (click)="openFilePreview(file)">
                                    {{ file.name | shorten: 30}}
                                </a>
                            </div>
                        </div>
                        <div  *ngIf="col.columnName == 'tags'" style="display: flex;">
                            <div *ngFor="let tag of data[col.columnName]">
                                <p-tag [value]="tag?.name" styleClass="p-ml-2" [style]="{'background-color': tag?.color}"></p-tag>
                            </div>
                        </div>
                    </ng-template>
                </span>
            </div>
        </ng-container>
        <div *ngIf="column2Address" class="p-mb-1 p-d-flex border-bottom p-p-2 detail-row">
            <div style="width: 25%;word-break: break-word;"><strong>{{column2Address.name}}</strong></div>
            <div style="width: 75%;">
                <p *ngIf="data && data['streetAddress1']" class="p-mb-0">{{data['streetAddress1']}},</p>
                <p *ngIf="data && data['streetAddress2']" class="p-mb-0">{{data['streetAddress2']}},</p>
                <p *ngIf="data && data['cityStateCountry']" class="p-mb-0">{{data['cityStateCountry']}}</p>
            </div>
        </div>
    </div>

    <ng-container *ngIf="leadScoreViewPermission && (moduleId == 1) && (leadScoreColumn || leadGradeColumn)">
        <p-divider layout="vertical"></p-divider>

        <div class="p-col-3 p-p-0 no-shadow">
            <p-card [style]="{'width': '100%'}">
                <h6 class="p-pb-3 p-mb-0" style="border-bottom: 1px solid #eee;">{{scoreName}}
                    <span class="pi pi-info-circle" pTooltip="{{scoreToolTip ?? ''}}" tooltipPosition="top"></span>
                </h6>
                <div class="p-grid p-mt-4">
                    <div *ngIf="leadScoreColumn" class="p-col-5">
                        <p-skeleton *ngIf="!leadsMLAIScore" width="6rem" height="3rem" borderRadius="16px"></p-skeleton>
                        <h1 style="color: var(--primary-color);" *ngIf="leadsMLAIScore">
                            {{leadsMLAIScore?.score == 0? 'N/A' : leadsMLAIScore?.score}}
                        </h1>
                    </div>
                    <div *ngIf="leadGradeColumn" class="p-col-7">
                        <p-skeleton *ngIf="!leadsMLAIScore" width="6rem" height="1rem" borderRadius="16px"></p-skeleton>
                        <h6 class="p-mb-2" *ngIf="leadsMLAIScore">Grade - {{leadsMLAIScore?.grade == null? 'N/A' :
                            leadsMLAIScore?.grade}}
                            <span class="pi pi-info-circle" pTooltip="{{gradeToolTip ?? ''}}" tooltipPosition="top"></span>
                        </h6>
                        <div class="p-d-flex">
                            <p-skeleton *ngIf="!leadsMLAIScore" width="8rem" height="2rem" borderRadius="16px"
                                [style]="{'margin-top': '25px'}"></p-skeleton>
                            <span *ngIf="leadsMLAIScore" style="position: relative;">
                                <img 
                                [src]="assestBaseUrl +'ai-images/'+ leadsMLAIScore?.graphIconName" 
                                    alt="leadScore"
                                    style="max-width:80px; max-height:40px" />
                                <span style="position:absolute; padding:7px;">
                                    {{leadsMLAIScore?.differenceFromLastScoreText}}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div *ngIf="leadsMLAIScore?.featureScore?.length>0 || leadScoreStaticFactors?.length>0" class="p-col-12">
                        <div class="score-progress-list">
                            <div class="score-progress-item" *ngFor="let featureScore of leadsMLAIScore?.featureScore"
                            [ngClass]="{'improving': featureScore?.difference>0, 'down': featureScore?.difference<0}">
                                <span *ngIf="featureScore?.difference>0" class="pi pi-arrow-up"></span>
                                <span *ngIf="featureScore?.difference<0" class="pi pi-arrow-down"></span>
                                <span *ngIf="!featureScore?.difference" class="pi pi-arrow-right"></span>
                                <span>{{ featureScore?.name }}</span>
                            </div>
                            <div class="score-progress-item improving" *ngFor="let factor of leadScoreStaticFactors">
                                <span class="pi pi-arrow-up"></span>
                                <span>{{ factor?.name }}: {{ factor?.value }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="leadScoreOtherFactors?.length>0" class="p-col-12">
                        <div class="missing-factors" (click)="leadFactors.toggle($event)">See Missing Information <span class="pi pi-arrow-down"></span></div>
                        <p-overlayPanel #leadFactors>
                            <div class="missing-factors-body">
                                <div class="missing-factors-item" *ngFor="let factor of leadScoreOtherFactors">
                                    <span class="pi pi-info-circle"></span> {{ factor.text }}
                                </div>
                            </div>
                        </p-overlayPanel>
                    </div>
                </div>
                <ng-template pTemplate="footer">
                    <div class="p-d-flex p-jc-between">
                        <p-skeleton *ngIf="!leadsMLAIScore" width="13rem" height="1rem" borderRadius="16px"></p-skeleton>
                        <p *ngIf="leadsMLAIScore">Last Updated: {{leadsMLAIScore?.lastUpdatedDate == null ? '' :
                            leadsMLAIScore?.lastUpdatedDate | dateAsAgoWithTimezone}}
                        </p>
                    </div>
                </ng-template>
            </p-card>
        </div>
    </ng-container>

    <ng-container *ngIf="oppScoreViewPermission && (moduleId == 3)">
        <p-divider layout="vertical"></p-divider>

        <div class="p-col-3 p-p-0 no-shadow">
            <p-card [style]="{'width': '100%'}">
                <h6 class="p-pb-3 p-mb-0" style="border-bottom: 1px solid #eee;">{{scoreName}}
                    <span class="pi pi-info-circle" pTooltip="{{scoreToolTip ?? ''}}" tooltipPosition="top"></span>
                </h6>
                <div class="p-grid p-mt-4">
                    <div class="p-col-5">
                        <p-skeleton *ngIf="!opportunityMLAIScore" width="6rem" height="3rem"
                            borderRadius="16px"></p-skeleton>
                        <h1 style="color: var(--primary-color);" *ngIf="opportunityMLAIScore">
                            {{opportunityMLAIScore?.score == 0? 'N/A' : opportunityMLAIScore?.score}}
                        </h1>
                    </div>
                    <div class="p-col-7">
                        <p-skeleton *ngIf="!opportunityMLAIScore" width="6rem" height="1rem"
                            borderRadius="16px"></p-skeleton>
                        <h6 class="p-ml-3 p-mb-2" *ngIf="opportunityMLAIScore">Grade - {{opportunityMLAIScore?.grade ==
                            null? 'N/A' : opportunityMLAIScore?.grade}}
                            <span class="pi pi-info-circle" pTooltip="{{gradeToolTip ?? ''}}" tooltipPosition="top"></span>
                        </h6>
                        <div class="p-d-flex">
                            <p-skeleton *ngIf="!opportunityMLAIScore" width="8rem" height="2rem" borderRadius="16px"
                                [style]="{'margin-top': '25px'}"></p-skeleton>
                            <span *ngIf="opportunityMLAIScore" style="position: relative;">
                                <img
                                [src]="assestBaseUrl + 'ai-images/' + opportunityMLAIScore?.graphIconName" 
                                alt="opportunityScore"
                                    style="max-width:80px; max-height:40px" />
                                <span style="position:absolute; padding:7px;">
                                    {{opportunityMLAIScore?.differenceFromLastScoreText}}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div *ngIf="opportunityMLAIScore?.featureScore?.length>0 || opportunityScoreStaticFactors?.length>0" class="p-col-12">
                        <div class="score-progress-list">
                            <div class="score-progress-item" *ngFor="let featureScore of opportunityMLAIScore?.featureScore"
                            [ngClass]="{'improving': featureScore?.difference>0, 'down': featureScore?.difference<0}">
                                <span *ngIf="featureScore?.difference>0" class="pi pi-arrow-up"></span>
                                <span *ngIf="featureScore?.difference<0" class="pi pi-arrow-down"></span>
                                <span *ngIf="!featureScore?.difference" class="pi pi-arrow-right"></span>
                                <span>{{ featureScore?.name }}</span>
                            </div>
                            <div class="score-progress-item improving" *ngFor="let factor of opportunityScoreStaticFactors">
                                <span class="pi pi-arrow-up"></span>
                                <span>{{ factor?.name }}: {{ factor?.value }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="opportunityScoreOtherFactors?.length>0" class="p-col-12">
                        <div class="missing-factors" (click)="oppFactors.toggle($event)">See Missing Information <span class="pi pi-arrow-down"></span></div>
                        <p-overlayPanel #oppFactors>
                            <div class="missing-factors-body">
                                <div class="missing-factors-item" *ngFor="let factor of opportunityScoreOtherFactors">
                                    <span class="pi pi-info-circle"></span> {{ factor.text }}
                                </div>
                            </div>
                        </p-overlayPanel>
                    </div>
                </div>
                <ng-template pTemplate="footer">
                    <div class="p-d-flex p-jc-between">
                        <p-skeleton *ngIf="!opportunityMLAIScore" width="13rem" height="1rem"
                            borderRadius="16px"></p-skeleton>
                        <p *ngIf="opportunityMLAIScore">Last Updated: {{opportunityMLAIScore?.lastUpdatedDate == null ? '' :
                            opportunityMLAIScore?.lastUpdatedDate | dateAsAgoWithTimezone}}
                        </p>
                    </div>
                </ng-template>
            </p-card>
        </div>
    </ng-container>


</div>

<app-shared-detail-popup *ngIf="displayDetailPopup" [moduleType]="moduleType" [currentDisplay]="displayDetailPopup"
    [dataId]="dataId" [associationTypeId]="associationTypeId" [header]="popupHeader" [column]="popUpColumns"
    (dialogClosed)="closeDialog()">
</app-shared-detail-popup>


<!-- Account Edit Component -->
<app-edit-account *ngIf="displayAccountViewEdit"
    [displayEditViewDialog]="displayAccountViewEdit"
    [displayView]="true"
    [selectedAccountId]="selectedAccountId"
    (getAccountListAfterEdit)="reloadResultAfterSave()" (closeModal)="closeAccountViewEditModal()">
</app-edit-account>

<!-- Lead View/Edit -->
<app-add-update-view-lead *ngIf="displayLeadViewEdit" [display]="true"
    [selectedLeadId]="selectedLeadId"
    [selectedChannelId]="selectedChannelId"
    [crudType]="'view'" (cancelClicked)="closeLeadViewEdit()"
    (onComplete)="reloadResultAfterSave()">
</app-add-update-view-lead>

<!-- Opportunity View/Edit -->
<app-opportunity-add-edit-dialog *ngIf="displayOpportunityViewEdit" [displayAddEditDialog]="displayOpportunityViewEdit"
    [opportunityChannelId]="selectedChannelId"
    [accountChannelId]="selectedAccountChannelId"
    [opportunityId]="opportunityEditViewId" [crudType]="'view'"
    (reloadList)="reloadResultAfterSave($event)"
    (closeModal)="closeOpportunityViewEdit()">
</app-opportunity-add-edit-dialog>

<p-toast position="top-right" [baseZIndex]="10000"></p-toast>

<!-- File Opener Modal -->
<app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile"
    (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>
